import { createContext } from "react";

export const ContentModalContext = createContext();
